

const UnstakeConfirmModal: React.FC<{
    handleCloseModal: () => void;
    handleSubmit: () => void;
}> = ({
    handleCloseModal,
    handleSubmit
}) => {
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-gray-200 dark:bg-gray-800 rounded-lg p-4 sm:p-6 w-full max-w-md mx-4">
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-lg sm:text-xl font-semibold text-gray-900 dark:text-white">
                        Confirm Unstake
                    </h2>
                    <button
                        onClick={handleCloseModal}
                        className="text-gray-500 hover:text-gray-700 dark:text-white dark:hover:text-gray-300 p-1"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>
                <p className="text-sm text-gray-700 dark:text-white mb-4">
                    Are you sure you want to unstake all your assets? This action cannot be undone.
                </p>
                <div className="flex justify-end gap-2">
                    <button
                        onClick={handleCloseModal}
                        className="px-4 py-2 text-gray-700 dark:text-gray-300 bg-gray-300 dark:bg-gray-600 hover:bg-gray-400 dark:hover:bg-gray-500 rounded-[100px] transition-colors"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={() => {
                            handleSubmit();
                            handleCloseModal();
                        }}
                        className="px-4 py-2 text-white dark:text-black rounded-[100px] transition-colors bg-red-500 hover:bg-red-700"
                    >
                        Unstake All
                    </button>
                </div>
            </div>
        </div>
    );
}

export default UnstakeConfirmModal;